<!--隐私协议-->
<template>
    <div class="instruction">

        <div class="header">

            <div class="header-back">
                <div class="title">
                    <div class="title_text">爱驿站是一家互联网婚恋公司</div>
                    <div class="title_text">专注婚恋领域十年</div>
                </div>

                <div class="title_desc">
                    <p>爱驿站创始于2014年，是一家全国连锁互联网婚恋服务品牌，拥有海量优质会员。以线下门店实名审核＋线上软件交互＋免费门店红娘服务的高效婚配服务模式，为单身男女提供真实、高效、免费的一站式婚恋服务。</p>
                </div>

                <div class="join_piece">
                    <div class="join_title">详细说明</div>
                </div>
            </div>


        </div>

        <div class="container">
            <div class="condition">
                <div class="condition_title">注册用户和实名用户的定义：</div>
                <div class="condition_text">
                    <p>“注册用户”是用户通过自己手机注册的普通会员。</p>
                    <p>“实名用户“是爱驿站线下门店实名资料审核登记的会员。</p>
                </div>
            </div>
            <div class="condition">
                <div class="condition_title">注册用户和实名用户功能差别：</div>
                <div class="condition_text">
                    <p>“注册用户”仅能使用APP的正常查看会员资料功能，无法与其他“实名会员”进行聊天、点赞、留言等交互。</p>
                    <p>“实名用户”可以使用APP上的所有功能。</p>
                </div>
            </div>
            <div class="condition">
                <div class="condition_title">成为实名用户条件：</div>
                <div class="condition_text">
                    <p>年满18岁以上的单身男女</p>
                </div>
            </div>
            <div class="condition">
                <div class="condition_title">实名门店登记需要哪些资料：</div>
                <div class="condition_text">
                    <p>基础资料（必需）：</p>
                    <p>身份证、户口本、婚姻状况证明（可到店网上查询）</p>
                    <p>其他资料（非必需）：</p>
                    <p>房产证、行驶证、学历证书、收入证明、工作证明等</p>
                    <p>以上资料，提供则给录入APP资料页面，不提供资料界 面则显示“无”。</p>
                    <p>资料一经提交，本人无权在App上进行修改，如需修改必须到门店审核验证后更改。</p>
                    <p>您提供的资料越多，越可以获得其他用户的信任和青映。也会获得平台更多的曝光流量和机会。</p>
                </div>
            </div>
            <div class="condition">
                <div class="condition_title">可以委托其他人帮我登记吗？</div>
                <div class="condition_text">
                    <p>爱驿站为保证资料的完整和真实性，必须本人持相关证件和证明资料才能进行登记注册。现场还需要测量身高和体重等数据。</p>
                    <p>所有资料提交后，必须本人签订《资料真实性协议》，如出现虚假资料，爱驿站可追究其法律责任。</p>
                </div>
            </div>
            <div class="condition">
                <div class="condition_title">整个流程多久可以完成？</div>
                <div class="condition_text">
                    <p>资料登记10到20分钟；</p>
                    <p>然后提交到总公司后台进行核实审批，需要1-2天;</p>
                    <p>核实无误后，通过短信通知的形式通知用户完成注册；</p>
                    <p>审核出现问题，通过人工客服和短信的形式通知用户到店更正修改，并再次提交，此过程不限次数。</p>
                </div>
            </div>

            <div class="condition">
                <div class="condition_title">人在外地还需要回到户籍地登记注册吗？</div>
                <div class="condition_text">
                    <p>爱驿站是全国连锁模式，任何一家门店都可以完成注册登记等服务，不受地域限制。</p>
                </div>
            </div>

            <div class="condition">
                <div class="condition_title">爱驿站会人工或红娘为您匹配异性吗？</div>
                <div class="condition_text">
                    <p>爱驿站所有服务均在APP软件上展开，所有红娘或电话通知等形式要为您匹配合适异性的都是骗子！遇到此类行为，请及时向平台或公安机关反馈举报。</p>
                </div>
            </div>

            <div class="condition">
                <div class="condition_title">爱驿站登记需要收费吗？</div>
            </div>
            <div class="condition">
                <div class="condition_title">免费服务!免费服务!免费服务!</div>
                <div class="condition_text">
                    <p>尊敬的用户们:</p>
                    <p>我们很高兴地宣布，爱驿站所有线下门店均提供免费服务!这是我们对广大用户的承诺，也是我们对社会责任的践行。</p>
                    <p>在爱驿站，您无需支付任何费用即可享受到我们提供的各项服务。我们致力于打造一个温馨、便捷、高效的服务环境，让您在享受服务的同时，也能感受到我们的用心与关怀。</p>
                    <p>然而，我们也深知，服务过程中难免会出现一些问题或不足。如果您在体验我们的服务过程中，发现有收费行为服务态度差或其他任何不符合我们服务标准的情况，我们诚挚地邀请您拨打我们的全国客服电话:400-6622-521进行投诉举报。您的每一条反馈都是对我们工作的监督和鞭策，我们将认真倾听、及时处理，并不断改进我们的服务。</p>
                    <p>此外，聊天室、红娘服务等，这些服务同样也将完全免费，不收取您一分钱费用。我们希望通过这些多样化的服务，为您的生活增添更多乐趣和便利。</p>
                    <p>在此，我们再次重申:爱驿站所有线下门店的服务均免费!我们期待您的光临，并希望我们的服务能为您带来愉悦的体验。让我们一起携手，共创美好未来!</p>
                </div>
            </div>

            <div class="buttons">
                <div class="station-btn" @click="onSearch">门店查询</div>
                <div class="line-btn" @click="onService">加盟热线</div>
            </div>
            
        </div>

    </div>
    <div class="footer">
        <p>江苏爱驿站信息科技有限公司</p>
        <p style="margin-top: -15px">Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
    </div>
</template>
<script>

import {isAndroid, isIOS, isWebView} from "@/assets/js/common";
import ayzAjax from "@/plugins/axios";

export default {
    name: "PolicyView",
    data: function () {
        return {
            franchise_phone:'0516-83000520'
        }
    },
    created() {
        this.getService()
    },
    methods: {
        onSearch(){
            let param = {};
            param.eventType = 1;//门店列表
            param = JSON.stringify(param)
            if(isIOS() && isWebView()){
                window.webkit.messageHandlers.ayz_interactive.postMessage(param);
            }
            if (isAndroid() && isWebView()){
                window.Android.ayz_interactive(param);
            }
        },
        onService(){
            let param = {};
            param.eventType = 2;//拨打电话
            param.phoneNumber = this.franchise_phone;
            param = JSON.stringify(param)
            if(isIOS() && isWebView()){
                window.webkit.messageHandlers.ayz_interactive.postMessage(param);
            }
            if (isAndroid() && isWebView()){
                window.Android.ayz_interactive(param);
            }
        },
        getService(){
            ayzAjax.get('/get_service').then((response) => {
                if (response.data.data.franchise_phone.length > 1){
                    this.franchise_phone = response.data.data.franchise_phone;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.instruction{
    //display: flex;
    width: 100%;
    justify-content: center; /* 水平居中 */
    align-items: center;
    min-height: 300px;
    background: #F8F8F8;

    .header{
        width: 100%;
        text-align: left;
        background-image: url('~@/assets/instruction_background.png');
        //background-size: contain;
        background-size: 100% auto;
        background-repeat: no-repeat;
        padding-top: 350px;
        margin-bottom: 30px;
        .header-back{
            position: relative;
            top: 20px; /* 相对于最近的非static定位父元素向下移动50px */
            //right: 30px; /* 向右移动30px */
            margin-top: 20px;
            justify-content: center; /* 水平居中 */
            align-items: center;
            margin-left: 10px;
            margin-right: 10px;
            background-image: url('~@/assets/policy_background2.png');
            //background-size: contain;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding: 20px 10px 20px 10px;


            .title{
                margin-top: 10px;
                text-align: center;
                .title_text{
                    color: #222222;
                    text-align: center;
                    font-weight: bold;
                    font-size: 20px;
                    margin-top: 10px;
                }
            }
            .title_desc{
                margin-top: 20px;
                text-align: left;
                padding: 0 15px 0 15px;
            }
            .join_piece{
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center;
                margin-top: 20px;
                //margin-bottom: 20px;
                .join_title{
                    width: 90%;
                    height: 49px;
                    background-color: #FE405F;
                    text-align: center;
                    line-height: 49px;
                    color: #ffffff;
                    border-radius: 10px;
                    font-size: 15px;
                }
            }
        }

    }

    .container{
        min-height: 500px;
        margin: 10px 15px 20px 15px;
        padding: 10px 10px 80px 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
        .condition{
            padding-top: 20px;
            text-align: left;
            text-indent: 1em;
            .condition_title{
                color: #111111;
                font-size: 15px;
                font-weight: bold;
            }
            .condition_text{
                margin-top: 10px;
                margin-bottom: 10px;
                padding-top: 5px;
                font-size: 14px;
            }

        }

    }
    .buttons{
        //display: flex;
        margin-top: 50px;
        .station-btn{
            width: 140px;
            height: 50px;
            line-height: 50px;
            float: left;
            text-align: center;
            background-color: #FE405F;
            border-radius: 10px;
            color: #FFFFFF;
        }
        .line-btn{
            width: 140px;
            height: 50px;
            line-height: 50px;
            float: right;
            text-align: center;
            //background-color: #FE405F;
            border: #FE405F 1px solid;
            border-radius: 10px;
            color: #FE405F;
            //font-weight: bold;
        }
    }

}
.footer{
    margin-top: 30px;
    //padding-bottom: 20px;
    text-align: center;
    p{
        color: #A5A5A5;
        font-weight: 300;
        font-size: 12px;
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 14px;
    color: #000000;
    overflow-wrap: break-word;  /* 标准属性 */
}

</style>
